import React from "react";
import Img from "gatsby-image";
import { getFluidGatsbyImage } from "gatsby-source-sanity";
import clientConfig from "../../../client-config";
import { FadeInUp } from "components";

export default ({ node }) => {
  if (!node || !node.asset || !node.asset._id) {
    return null;
  }
  const fluidProps = getFluidGatsbyImage(node.asset._id, { maxWidth: 675 }, clientConfig.sanity);
  return (
    <FadeInUp>
      <figure>
        <Img fluid={fluidProps} alt={node.alt} />
      </figure>
    </FadeInUp>
  );
};
